export const promote = (config) => ({
    ...config,
    retryEnabled: false,
    maxRetries: 3,
    retryDelaySeconds: 5
});
//# sourceMappingURL=webhook-webhook-4-to-5.js.map